// js-buy-vip.js
;(({ $, $$ , log}) => {
    $$('.js-buy-vip').forEach(tool => {
        const select = tool.querySelector('.js-buy-vip__type-select')
        const previews = tool.querySelectorAll('.js-buy-vip__preview')
        const previewControls = tool.querySelectorAll('.js-buy-vip__preview-controls')

        if (!select || previews.length == 0 || previewControls.length == 0) { return }

        init()

        function init() {
            initPreview()
        }

        function initPreview() {
            const type = select.querySelector('.ro-select__input').value
            updatePreview(type)
            updatePreviewControls(type)

            select.addEventListener('change', event => {
                updatePreview(event.value)
                updatePreviewControls(event.value)
            })
        }


        function updatePreview(type) {
            previews.forEach(output => {
                output.innerHTML = 
                    getPreviewHTML(type) +
                    getPreviewHTML('blue') +
                    getPreviewHTML('blue')
            })
        }

        function updatePreviewControls(selectType) {
            previewControls.forEach(preview => {
                preview.querySelectorAll('.js-buy-vip__preview-controls-section').forEach(section => {
                    const { type } = section.dataset
                    if (type === selectType) {
                        section.removeAttribute('style')
                    } else {
                        section.style.display = 'none'
                    }
                })
            })
        }
    })

    function getPreviewHTML(type) {
        const previewHTMLs = {
            red: `
                <div class="servers-table__row servers-table__row--premium">
                    <div class="servers-table__mark">
                        <img src="/site/img/icons/misc/diamond.svg" alt="diamond">
                    </div>
                    <a href="#" class="servers-table__name one-line">L2mad.net</a>
                    <span class="servers-table__rate">x100</span>
                    <span class="servers-table__version">Homunculus</span>
                    <span class="servers-table__date">25.02.23</span>
                </div>
            `,
            yellow: `
                <div class="servers-table__row servers-table__row--vip">
                    <div class="servers-table__mark">
                        <div class="tag tag--vip">VIP</div>
                    </div>
                    <a href="#" class="servers-table__name one-line">Interlude.club</a>
                    <span class="servers-table__rate">x9999</span>
                    <span class="servers-table__version">Grand Crusade</span>
                    <span class="servers-table__date tag">Сегодня</span>
                </div>
            `,
            blue: `
                <div class="servers-table__row ">
                    <div class="servers-table__mark">
                        <span class="servers-table__dot"></span>
                    </div>
                    <a href="#" class="servers-table__name one-line">l2server.net</a>
                    <span class="servers-table__rate">x100</span>
                    <span class="servers-table__version">C4</span>
                    <span class="servers-table__date">25.02.23</span>
                </div>
            `,
        }

        return previewHTMLs[type]
    }
})(CNS);